module.exports = __webpack_public_path__ + "static/media/STPProjectPrevieww1870@2x.cfcc5e28.webp";